// reducers/transportReducer.js
export const transportReducer = (
  state = {
    routes: [],
    buses: [],
    stops: [],
    dailyLogs: [],
    myTransport: null,
    myChildrenTransport: [],
    transportHistory: [],
  },
  action,
) => {
  switch (action.type) {
    case "TRANSPORT_REQUEST":
      return { ...state, loading: true };
    case "GET_ROUTES_SUCCESS":
      return { ...state, loading: false, routes: action.payload };
    case "GET_BUSES_SUCCESS":
      return { ...state, loading: false, buses: action.payload };
    case "STOPS_SUCCESS":
      return { ...state, loading: false, stops: action.payload };
    case "DAILY_LOGS_SUCCESS":
      return { ...state, loading: false, dailyLogs: action.payload };
    case "MY_TRANSPORT_SUCCESS":
      return { ...state, loading: false, myTransport: action.payload };
    case "TRANSPORT_HISTORY_SUCCESS":
      return { ...state, loading: false, transportHistory: action.payload };
    case "STAFF_ASSIGNMENT_HISTORY_SUCCESS":
      return {
        ...state,
        loading: false,
        staffAssignmentHistory: action.payload,
      };
    case "ATTENDANCE_ROSTER_SUCCESS":
      return { ...state, loading: false, attendanceRoster: action.payload };
    case "MY_CHILDREN_TRANSPORT_SUCCESS":
      return { ...state, loading: false, myChildrenTransport: action.payload };
    case "ASSIGN_TRANSPORT_SUCCESS":
      return { ...state, loading: false, success: true };
    case "TRANSPORT_FAIL":
      return { ...state, loading: false, error: action.payload };
    case "CLEAR_ERRORS":
      return { ...state, error: null, success: false };
    default:
      return state;
  }
};
